<script setup lang="ts">
import VButton from '@/modules/shared/components/v-button.vue'

const props = defineProps<{
  embedTarget?: string
  showModal: boolean
  error?: string | null
}>()

defineEmits<{
  (e: 'closeEditor'): void
}>()
</script>

<template>
  <Teleport to="body">
    <div v-show="showModal" class="fixed inset-0 top-1 z-50 flex flex-col bg-white">
      <div class="relative flex flex-none items-center justify-between border-b p-3">
        <div>
          <h3 class="font-medium leading-7 text-gray-700 dark:text-gray-300">Sign Document</h3>
        </div>
        <div
          v-if="error"
          class="pointer-events-none absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center gap-2 rounded-full border border-red-200 bg-red-50 px-3 py-1 text-sm font-medium text-red-700 shadow-sm"
        >
          <span>{{ error }}</span>
        </div>
        <VButton variant="primary" @click="$emit('closeEditor')">Close</VButton>
      </div>

      <div class="min-h-0 flex-1">
        <div :id="embedTarget" class="h-full w-full"></div>
      </div>
    </div>
  </Teleport>
</template>
